document.addEventListener("DOMContentLoaded", 
    function() {
        function BlogSearch() {
            this.searchInput = document.querySelector("[data-blog-search]");
            if (!this.searchInput) return;

            this.initBlogSearch();

            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);
            var currentValue = params.get("search");
            if (currentValue) {
                this.searchInput.value = currentValue;
                let parent = this.searchInput.closest(".form-group");
                if (parent) {
                    parent.classList.add("input-focused");
                }
                this.performSearch(currentValue, true);
            }
        }

        BlogSearch.prototype.initBlogSearch = function() {

            var timeout;
            this.searchInput.addEventListener("input", function(e){
                clearTimeout(timeout);
                timeout = setTimeout(this.performSearch.bind(this), 1500);
            });
            this.searchInput.addEventListener("change", this.performSearch);
        };

        BlogSearch.prototype.performSearch = function(value, dontCheck = false) {
            const searchedValue = this.value ?? value;
            if (!searchedValue || searchedValue == '' || searchedValue.length < 3) return;

            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);
            var currentValue = params.get("search");

            if (dontCheck == false) {
                if (searchedValue == currentValue) return;
            }

            params.set("search", searchedValue);

            currentUrl.search = params.toString();
            history.replaceState({}, "", currentUrl);

            const bodyLoader = document.getElementById("bodyLoader");
            bodyLoader.classList.remove("hidden");

            fetch('/search?q=' + encodeURIComponent(searchedValue) + '&type=article&view=article-grid-items')
            .then((response) => response.text())
            .then((body) => {
                const bodyLoader = document.getElementById("bodyLoader");
                bodyLoader.classList.add("hidden");

                let parser = new DOMParser();
                let doc = parser.parseFromString(body, "text/html");
                const resultGrid = doc.getElementById("ProductGridContainer");

                document.getElementById("blogSearchResult").classList.remove("hidden")
                document.querySelector("[data-main-blog-content]").classList.add('hidden');

                if (resultGrid.querySelectorAll("li").length <= 0) {
                    document.querySelector("#blogSearchResult [data-results]").innerHTML = `No result found for '${searchedValue}'`;
                } else {
                    document.querySelector("#blogSearchResult [data-results]").innerHTML = resultGrid.innerHTML;
                }

            });

        }

        return new BlogSearch();
    }
);